import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import {
  getCurriculumState,
  getCurriculumsForHomePage,
} from '../../store/CurriculumSlice';
import { useAppSelector } from '../../hooks';
import FullScreenLoader from '../../components/Loaders/FullScreenloader';
import { getUrlConvertedString } from '../../helper';

const VerifyNotesLink: React.FC = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  // Store
  const curriculumState = useAppSelector(getCurriculumState);

  const curriculums = curriculumState.curriculumsForHomePage;
  const queryStringParams = new URLSearchParams(location.search);

  const curriculum = queryStringParams.get('curriculum') || '';
  const subject = queryStringParams.get('subject') || '';
  const grade = queryStringParams.get('grade') || '';
  const subjectCode = queryStringParams.get('subjectCode') || '';
  const idToken = queryStringParams.get('userToken') || '';
  const userId = queryStringParams.get('userId') || '';

  useEffect(() => {
    dispatch(getCurriculumsForHomePage());
  }, []);

  useEffect(() => {
    if (curriculums && curriculums.length) {
      const selectedCurriculum = curriculums.find(
        (curriculumItem) => curriculumItem.name === curriculum
      );

      if (
        selectedCurriculum &&
        selectedCurriculum.subjects &&
        selectedCurriculum.subjects.length
      ) {
        const selectedSubject = selectedCurriculum.subjects.find(
          (subjectItem) => {
            if (grade) {
              return (
                subjectItem.name === subject &&
                subjectItem.subjectCode === subjectCode &&
                subjectItem.grade === grade
              );
            }

            return (
              subjectItem.name === subject &&
              subjectItem.subjectCode === subjectCode
            );
          }
        );

        if (
          selectedSubject &&
          selectedSubject.subTopic &&
          selectedSubject.subTopic._id
        ) {
          const urlConvertedCurriculum = getUrlConvertedString(curriculum);
          const urlConvertedSubject = getUrlConvertedString(subject);
          const urlConvertedSubTopic = getUrlConvertedString(
            selectedSubject.subTopic.name
          );

          let redirectUrlPath = `dashboard/my-quizzes/resources/subtopic/${urlConvertedCurriculum}_${urlConvertedSubject}_${urlConvertedSubTopic}_${selectedSubject.subTopic._id}`;

          if (idToken && userId) {
            redirectUrlPath += `#id_token=${idToken}&user_id=${userId}`;
          }

          window.location.href = `${redirectUrlPath}`;
        }
      }
    }
  }, [curriculums]);

  return <FullScreenLoader />;
};

export default VerifyNotesLink;
